module.exports = __webpack_public_path__ + "media/images/wf_logo_4-2360a8c51de6e842879f8dc1523a6596.png";